export default __webpack_public_path__ + "static/media/hex-pave.cf72d9ba.jpg";